import * as isofetch from 'isomorphic-fetch';
import {StorageKey} from '../util/Storage';

export function fetch(input: RequestInfo, init?: RequestInit): Promise<Response> {

    init = init || {};
    init = {
        ...init,
        credentials: 'include',
        headers: {
            ...init.headers
        }
    };

    if (init.body && !(init.headers && init.headers['Content-Type'])) {
        init = {
            ...init,
            headers: {
                ...init.headers,
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        };
    }

    return isofetch(input, init).then((resp: Response) => {
        if (resp.ok) {
            localStorage.removeItem(StorageKey.ApiError);
            localStorage.removeItem(StorageKey.BackendFailure);
            let tokenExpirationString = resp.headers.get('Token-Expiration');
            if (tokenExpirationString) {
                localStorage.setItem(StorageKey.TokenExpiration, `${(+(tokenExpirationString as string) || 120) * 1000 + Date.now()}`);
            }
            return Promise.resolve(resp);
        }
        if (resp && resp.status === 401) {
            // Unauthorized, reset token
            localStorage.removeItem(StorageKey.Authenticated);
            localStorage.removeItem(StorageKey.TokenExpiration);
            return Promise.reject(resp);
        }
        return Promise.reject(resp);
    }).catch((resp: Response) => {
        return Promise.reject(resp);
    });
}

export function processError(err?: any): Promise<any> {
    let resp = err as Response;
    let parsedError = undefined;
    if (typeof (resp.json) == 'function') {
        return resp.json().catch(() => {
            return Promise.reject(undefined);
        }).then(function (json) {
            parsedError = json;
            return Promise.reject(parsedError);
        });
    } else if (resp['response'] && resp['response'].data) {
        parsedError = resp['response'].data;
    }
    return Promise.reject(parsedError);
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/api/fetch.ts